import { gql } from "@outschool/ui-apollo";

export default gql`
  fragment PublicReviewFragment on PublicReview {
    uid
    section_uid
    currentUserCanEdit
    currentUserCanRespond
    details {
      publicReview
    }
    activity_star_rating
    currentUserMarkedHelpful
    markedHelpfulCount
    created_at
    teacher_response
    teacher_responded_at
    activity {
      uid
      isClub
      slug_id
      title
      user_uid
      leader {
        uid
        name
        leader_link
        photo
      }
    }
    attachments {
      uid
      file {
        filename
        mimetype
        size
        url
        thumbUrl
      }
      conversionStatus
      created_at
    }
    parent {
      uid
      name
      photo
      publicName
      introduction
      created_at
      deleted_at
      timeZone
      socialOptOut
      consent_to_share_class_history
      consent_to_share_favourites
    }
  }
`;
